import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'boook_admin';

  constructor(private translate: TranslateService) {
    this.translate
      .use(navigator.language)
      .toPromise()
      .catch(() => this.translate.use('en'));
  }
}
